<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="date"
                            v-model="referencia">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="load(false)">
                                        <i class="fas fa-sync-alt fa-fw"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            placeholder="Unidades..."
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            icon="fa fa-building fa-fw"
                            v-model="filtro.id_unidade_operacao" />
                    </div>
                    <div class="col col-12" :class="vacina ? 'col-md-8' : 'col-md-4'">
                        <az-input
                            icon="fa fa-filter fa-fw"
                            type="select"
                            :optionsList="filas.map(item => { return { id: item.id_fila_laudo, search: item.search } })"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtro.id_fila_laudo"
                            :edicao="!$store.state.loading"
                            @input="load()" />
                    </div>

                    <div class="col col-12 col-md-4" v-if="!vacina">
                        <template v-if="filtro_lista_medicos && filtro_lista_medicos.length">
                            <az-input
                                type="label"
                                icon="fas fa-user-md fa-fw"
                                placeholder="Lista Selecionada"
                                label="Lista Selecionada"
                                value="Lista Selecionada">
                                <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="!filtro.id_medico">
                                    <span class="input-group-text" id="basic-addon2" v-if="filtro_lista_medicos && filtro_lista_medicos.length">
                                        {{ filtro_lista_medicos.length }}
                                    </span>
                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" data-toggle="tooltip" data-placement="top" title="Selecionar Profissionais" @click="selecionar_medicos()">
                                        <i class="fa-solid fa-list-check"></i>
                                    </button>
                                </div>
                                </template>
                            </az-input>
                        </template>

                        <template v-else>
                            <az-input icon="fas fa-user-md fa-fw" 
                                type="select" 
                                placeholder="Todos os Profissionais..."
                                optionsMode="aql"
                                service="medicos.index"
                                optionsName="medicos-cadastro-assistencia"
                                :optionsParm="{ ativos: true, atendimento: true }"
                                optionsData="id_pessoa"
                                v-model="filtro.id_medico">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" data-toggle="tooltip" data-placement="top" title="Selecionar Profissionais" @click="selecionar_medicos()">
                                            <i class="fa-solid fa-list-check fa-fw"></i>
                                        </button>

                                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" data-toggle="tooltip" data-placement="top" title="Agrupar/Desagrupar por Profissionais"
                                            @click="viewMode == 'A' ? viewMode = 'G' : viewMode = 'A'">
                                            <i class="fas fa-object-group fa-fw" v-if="viewMode == 'A'"></i>
                                            <i class="fas fa-object-ungroup fa-fw" v-else></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </template>
                    </div> 
                </div>
                <div class="form-row mt-2">
                    <div class="col col-12">
                        <az-input icon="fa fa-search fa-fw" v-model="search" @input="refresh_se_necessario()" @onEnter="load(false)">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn dropdown-toggle" :class="faixa_hora ? 'btn-secondary' : 'btn-outline-secondary'" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="far fa-clock mr-1" v-if="!faixa_hora"></i>
                                        <span v-else class="mr-1">{{ faixa_hora }}</span>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="faixa_hora = 'M'">Manhã (&lt;13)</a>
                                        <a class="dropdown-item" href="#" @click.prevent="faixa_hora = 'T'">Tarde (13-18)</a>
                                        <a class="dropdown-item" href="#" @click.prevent="faixa_hora = 'N'">Noite (&gt;18)</a>
                                        <a class="dropdown-item" href="#" @click.prevent="faixa_hora = 'TN'">Tarde/Noite ((&gt;13)</a>
                                        <div role="separator" class="dropdown-divider"></div>
                                        <a class="dropdown-item" href="#" @click.prevent="faixa_hora = ''">Todos</a>
                                    </div>
                                </div>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="painel()">
                                        <i class="fas fa-tv fa-fw"></i>
                                    </button>
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="pausar_login()">
                                        <i class="fa fa-pause fa-fw" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>                    
                </div>

                <div class="form-row mt-2" v-if="is_fila_intern">
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="checkbox-group"
                            label="Internados"
                            v-model="filtro.internados" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            placeholder="Unidade de Internação..."
                            icon="fa-solid fa-location-dot fa-fw"
                            type="select"
                            optionsMode="aql"
                            :optionsName="'centro_custos.index.leito.' + filtro.id_unidade_operacao"
                            service="centro_custos.index"
                            optionsData="id_centro_custo" 
                            optionsDisplay="st_nome"
                            :optionsParm="{ 
                                ativos: true,
                                id_unidade_operacao: filtro.id_unidade_operacao,
                                leitos: true, 
                            }"
                            v-model="filtro.id_centro_custo">
                            <template v-slot:buttonposb v-if="filtro.id_centro_custo">
                                <div class="input-group-append">
                                    <span class="input-group-text small">
                                        #{{ filtro.id_centro_custo}}
                                    </span>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            icon="fa-solid fa-bed fa-fw"
                            placeholder="Selecione o leito do paciente..."
                            type="autocomplete" 
                            optionsMode="aql"
                            service="locals.index"
                            optionsName="locals.index.leitos"
                            :optionsSync="true"
                            v-model="filtro.local"
                            :optionsParm="{ 
                                ativos: true,
                                leitos: true, 
                                id_unidade_operacao: filtro.id_unidade_operacao, 
                                id_centro_custo: filtro.id_centro_custo, 
                            }">
                            <template v-slot:buttonposb v-if="filtro.local">
                                <div class="input-group-append">
                                    <span class="input-group-text small">
                                        #{{ filtro.local.id_local }}
                                    </span>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input 
                            icon="fa-solid fa-user fa-fw"
                            placeholder="Selecionar paciente..."
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="filtro.paciente" 
                            :optimized_ac="true">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="filtro.paciente">
                                    <button type="button" class="btn btn-outline-primary px-2" @click="$root.perfil(filtro.paciente);">
                                        <i class="fa fa-id-badge" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>
                    
                <!--
                <div class="form-row">
                    <div class="col col-12">
                        <az-input
                            class="mt-3"
                            :type="( filas && filas.length <= 5 ) ? 'button-group' : 'select'"
                            sizing="sm"
                            :optionsList="filas.map(item => { return { id: item.id_fila_laudo, search: item.search } })"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtro.id_fila_laudo"
                            :edicao="!$store.state.loading"
                            @input="load()" />
                    </div>
                </div>
                -->
            </div>
        </div>

        <div>
            <span class="badge badge-dark mr-1">
                {{ lista_status.reduce((total, carry) => total + carry.count, 0) }} / Total
            </span>
            <span class="badge mr-1" :class="'badge-' + ( status.color ? status.color : 'secondary' )" v-for="(status, isx) in lista_status" :key="isx">
                {{ status.count }} / {{ status.title }}
            </span>
        </div>

        <div class="progress mt-1 mb-1">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>    

        <az-empty-state v-if="!lista || !lista.length" />

        <!-- Lista de agendas -->
        <div v-else class="mt-3">

            <card-tarefas :tarefas="tarefas" />

            <div v-for="(quebra, iq) in exibicao" :key="iq">

                <div class="mt-3 mb-0 d-flex"> 
                    <h5 class="mb-0">
                        <a href="#" @click.prevent="toggle_retracao(iq)" v-if="viewMode != 'G'">
                            <i class="far fa-minus-square mr-2" v-if="!retracao[iq.substr(0,1)]"></i>
                            <i class="far fa-plus-square mr-2" v-else></i>
                        </a>
                        <span v-if="iq != ' Lista '">
                            {{ iq.substr(2) }}
                        </span>
                        <span class="badge badge-secondary">{{ quebra.length }}</span>
                    </h5>
                </div>

                <template v-if="!iq || !retracao[iq.substr(0,1)]">
                <div id="lista-de-trabalho">
                    <div class="mb-3 mx-3">
                        <div class="row my-2 py-1 dashcard align-items-center w3-animate-opacity bg-white" 
                            v-for="(item, index) in quebra" :key="index">
                            <!-- Ação -->
                            <div class="col-12 col-md-2 col-lg-2 text-center my-2 my-md-auto">
                                <div class="d-flex flex-column">
                                    <div class="btn-group" role="group" aria-label="Basic example">
                                        <template v-if="$store.state.user.id_pessoa == item.id_medico && item.id_atendimento">
                                            <button type="button" class="btn btn-outline-primary btn-sm px-1 my-2 my-md-0" @click="verConsultorio (item)"
                                                :disabled="$store.state.loading">
                                                <i class="fas fa-pills"></i>
                                            </button> 
                                        </template>

                                        <!-- || ( item.item_status && item.item_status.id_fila && item.item_status.id_fila != filtro.id_fila_laudo )" -->

                                        <button type="button" :disabled="( $store.state.loading && item.loading && checkStatus(item) )" 
                                            class="btn btn-sm my-2 my-md-0 text-nowrap text-truncate"
                                            :class="
                                                ( ( $store.state.user.id_pessoa == item.id_medico && item.id_atendimento ) ? 'ml-2 ' : '' ) + 
                                                'btn-' + ( checkStatus(item).fill ? '' : 'outline-' ) + checkStatus(item).color
                                            "
                                            @click="checkStatus(item).action ? checkStatus(item).action (item) : ''">
                                            <i class="mr-2" :class="checkStatus(item).icon" v-if="!$store.state.loading || !item.loading"></i> 
                                            <div class="spinner-border spinner-border-sm mr-2" role="status" v-else>
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                            {{ checkStatus(item).title }}
                                        </button>
                                    </div>
                                </div>

                                <div class="progress mt-1">
                                    <div class="progress-bar bg-success" role="progressbar" :style="'width: ' + percentual_execucao(item) + '%'"></div>
                                    <div class="progress-bar bg-warning" role="progressbar" :style="'width: ' + percentual_a_realizar(item) + '%'"></div>
                                </div>

                                <div v-if="item.item_status && item.item_status.info_fila && item.item_status.id_fila != filtro.id_fila_laudo" class="text-muted small text-nowrap text-truncate">
                                    {{ item.item_status.info_fila }}
                                </div>
                            </div>
                            <!-- Data -->
                            <div class="col col-12 col-md-2 d-flex justify-content-between"> 
                                <div>
                                    <div v-if="( fila && fila.fl_pre_atendimento && item.atendimento && item.atendimento.progresso_atendimento_consultorio && item.atendimento.progresso_atendimento_consultorio.etapa_atendimento )">
                                        <span class="badge" :class="'badge-' + cor_etapa(item)">
                                            {{ item.atendimento.progresso_atendimento_consultorio.etapa_atendimento.st_etapa_atendimento }}
                                        </span>
                                    </div>
                                    <div>
                                        <celula-horarios-marcacao :hor="{ marcacao: item }" :onlyPanel="false" @refresh="load()" block_editar2="true">
                                            <template v-slot:info="{ metodo_abrir_tempos }">
                                                <template v-if="false">
                                                    <a href="#" @click.prevent="metodo_abrir_tempos()" class="card-link">
                                                        {{ $util.getFormatDate(item.dt_inicio) }} {{ item.dt_inicio.substr(11,5) }}
                                                    </a>

                                                    <span class="ml-2">
                                                        <i :class="( item.sinalizador_atendimento.st_icon ? item.sinalizador_atendimento.st_icon : 'fas fa-flag' ) + ' text-' + item.sinalizador_atendimento.st_cor"
                                                            :title="item.sinalizador_atendimento.search" 
                                                            v-if="item && item.sinalizador_atendimento"></i>
                                                    </span>
                                                </template>
                                                <template v-else>
                                                    <span class="mr-1">{{ $util.getFormatDate(item.dt_inicio, 'DD/MM') }}</span>
                                                </template>
                                            </template>
                                        </celula-horarios-marcacao>

                                        <div v-if="!item.fl_adicao_direta
                                            && !item.fl_ordem_chegada
                                            && !item.id_atendimento
                                            && item.dt_inicio.substr(0,10) == $util.hoje() 
                                            && item.dt_inicio.substr(11,5) < ( item.dt_checkin ? item.dt_checkin.substr(11,5) : $util.agora() )">
                                            Atrasado
                                        </div>  
                                    </div>
                                    <template v-if="false && item.atendimento">
                                        <div>
                                            #{{ item.id_atendimento }}
                                            <span class="text-muted ml-2">
                                                {{ item.atendimento.dt_inicio.substr(11,5) }}
                                            </span>
                                            <span class="text-muted small ml-2"
                                                v-if="item.dt_inicio.substr(0,10) == $util.hoje() 
                                                    && !item.fl_adicao_direta
                                                    && !item.fl_ordem_chegada
                                                    && item.dt_inicio.substr(11,5) < ( item.dt_checkin ? item.dt_checkin : item.atendimento.dt_inicio ).substr(11,5)">
                                                Atrasado
                                            </span>  
                                        </div>
                                    </template>
                                    <div v-if="item.id_internacao" class="small text-muted">
                                        <div v-if="item.dt_admissao"> 
                                            <span class="mr-4" title="Admissão">
                                                <i class="fas fa-sign-in-alt"></i>
                                                {{ $util.getFormatDate(item.dt_admissao, 'DD/MM') }}
                                            </span>
                                            <span v-if="item.dt_alta" title="Alta"> 
                                                <i class="fas fa-sign-out-alt"></i>
                                                {{ $util.getFormatDate(item.dt_alta, 'DD/MM') }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <span data-toggle2="tooltip" data-placement="top" title="Evolução Registrada."
                                        v-if="item.evolucao_count">
                                        <i class="fas fa-notes-medical text-success"></i>
                                    </span>
                                    <span data-toggle2="tooltip" data-placement="top" title="Relatório Médico."
                                        v-if="item.doc_count">
                                        <i class="far fa-file-alt ml-1 text-warning"></i>
                                    </span>
                                    <span data-toggle2="tooltip" data-placement="top" title="Requisição Médica."
                                        v-if="item.requisicao_count">
                                        <i class="fa fa-heartbeat ml-1 text-info" aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                            <!-- Identificação do Paciente -->
                            <div class="col col-12 col-md-4" v-if="item">
                                <celula-dados-paciente :hor="{ marcacao: item }" />
                                <div v-if="item.st_leito" class="small text-muted">
                                    {{ item.st_leito }}
                                </div>
                            </div>

                            <div class="col col-12 col-md-4 d-flex justify-content-between">
                                <celula-dados-procedimento :hor="{ marcacao: item }" @abrirpreatend="$refs.doc_pre_atend.abrir" @abriranexos="abrir_anexar_arquivo" />

                                <!-- Menu de opções -->
                                <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                    <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </a>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <button class="dropdown-item" @click="iniciarAtendimento(item)" v-if="item && !item.atendimento">
                                            Registrar Atendimento
                                        </button>
                                        
                                        <button class="dropdown-item" @click="remarcar(item)" :disabled="item && item.atendimento" v-if="false">
                                            Remarcar
                                        </button>
                                        <button class="dropdown-item" v-if="false" @click="abrir_anexar_arquivo(item)" :disabled="!item">
                                            Anexar Arquivo
                                            <span class="badge badge-secondary" v-if="item.arquivos && item.arquivos.length">
                                                {{ item.arquivos.length }}
                                            </span>
                                        </button>
                                        <button class="dropdown-item" @click="$refs.doc_pre_atend.abrir(item)">
                                            Pré-Atendimento
                                            <span class="badge badge-secondary" v-if="item.doc_pre_atends && item.doc_pre_atends.length">
                                                {{ item.doc_pre_atends.length }}
                                            </span>
                                        </button>
                                        <template v-if="item">
                                            <button class="dropdown-item" @click="printEtiqueta(item)">Emitir Etiqueta</button>
                                            <button class="dropdown-item" @click="novoDocumento(item)">Emitir Documento</button>
                                            <div class="dropdown-divider"></div>
                                            <button class="dropdown-item" @click="adcionar_marcacao(item)">Nova Marcação</button>
                                        </template>
                                        <template v-if="paineis && paineis.length && item && item.atendimento">
                                            <div class="dropdown-divider"></div>
                                            <button class="dropdown-item" @click="selecionar_painel(item)" >
                                                Painel
                                            </button>
                                        </template>
                                        <template v-if="item.dt_inicio.substr(0,10) == $util.hoje() && item.id_atendimento">
                                            <div class="dropdown-divider"></div>
                                            <button class="dropdown-item" @click="chamar(item)" >
                                                Chamar Paciente
                                            </button>

                                            <button class="dropdown-item" @click="finalizar_pre(item)" v-if="pre_pode_finalizar && fila && fila.fl_pre_atendimento && ( checkStatus(item).status == 'chamar' || checkStatus(item).status == 'chamado-pre' )" >
                                                Finalizar Pré-Atendimento
                                            </button>

                                            <button class="dropdown-item" @click="finalizar(item)" v-if="pre_pode_finalizar && fila">
                                                Finalizar Atendimento do Profissional
                                            </button>
                                        </template>

                                        <template v-else-if="item.dt_inicio.substr(0,10) < $util.hoje() && item.id_atendimento">
                                            <div class="dropdown-divider"></div>
                                            <button class="dropdown-item" @click="finalizar(item)" v-if="pre_pode_finalizar && fila">
                                                Finalizar Atendimento do Profissional
                                            </button>
                                        </template>

                                        <template v-if="item.id_infusao && item.st_regiao">
                                            <div class="dropdown-divider"></div>
                                            <button class="dropdown-item" @click="agenda_infusao(item)">
                                                Agenda de Infusão
                                            </button>
                                        </template>

                                        <template v-if="is_fila_intern && item.id_internacao">
                                            <div class="dropdown-divider"></div>
                                            <button class="dropdown-item" @click="registrar_alta(item)">
                                                Alta
                                            </button>
                                            <button class="dropdown-item" @click="selecionar_leito(item)" v-if="item.st_leito && item.st_leito.slice(0,1) == '['">
                                                Selecionar Leito
                                            </button>
                                        </template>
                                        <!-- <a class="dropdown-item" href="#">Emitir Atestado</a> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </template>

            </div>

        </div>

        <!-- Modal -->
        <div class="modal fade" id="procedimentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ação</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="list-group" v-if="fila && laudo">
                            <button type="button" class="list-group-item list-group-item-action" :class="'list-group-item-' + status.st_color" 
                                v-for="(status, isx) in fila.lista_status" :key="isx"
                                :disabled="$store.state.loading" @click="laudo_status(status)">
                                {{ status.st_acao }}
                            </button>
                        </div>

                        <pre v-if="false">{{ fila }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="card panel-fullscreen" v-show="em_atend_fullscreen">
            <div class="card-header d-flex justify-content-between">
                <div>
                    Em Atendimento...
                </div>
                <div>
                    <button type="button" class="btn btn-link my-0 py-0" @click="execucao()" v-if="paineis && paineis.length">
                        <i class="fa-solid fa-circle-play"></i>
                    </button>
                    <button type="button" class="btn btn-link my-0 py-0" @click="painel()">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
            <div v-if="painel_execucao">
                <atendimento-enfermagem-painel ref="painel_execucao" />
            </div>
            <table class="table table-striped table-sm" v-else>
                <thead>
                    <tr>
                        <th>Local</th>
                        <th>Técnico</th>
                        <th>Paciente</th>
                        <th>Procedimentos</th>
                        <th>Início</th>
                        <th>Profissional</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, iix) in em_atendimento" :key="iix">
                        <td>
                            <a href="#" class="card-link mr-2" @click.prevent="editar_local(item)">
                                <i class="fas fa-edit"></i>
                            </a>
                            {{ item.atendimento.st_as_local }}</td>
                        <td>{{ item.atendimento.st_as_resp }}</td>
                        <td>
                            {{ item.paciente.st_nome }}
                        </td>
                        <td>
                            <div class="h4">
                                <span class="badge ml-1" :class="'badge-' + proc.color" v-for="(proc, ipx) in lista_procs(item)" :key="ipx">
                                    {{ proc.descricao }}
                                    <span>{{ proc.duracao }}</span>
                                </span>
                            </div>
                            <div class="progress mb-1">
                                <div class="progress-bar bg-success" role="progressbar" :style="'width: ' + percentual_execucao(item) + '%'"></div>
                                <div class="progress-bar bg-warning" role="progressbar" :style="'width: ' + percentual_a_realizar(item) + '%'"></div>
                            </div>
                        </td>
                        <td>
                            <span v-if="item.item_status.dt_ultimo">
                                {{ item.item_status.dt_ultimo.substr(11,5) }}
                            </span>
                        </td>
                        <td>{{ item.medico.st_nome_exibicao }}</td>
                    </tr>
                </tbody>    
            </table>

        </div>

        <br><br><br><br><br>

        <!-- Paginação -->
        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.last_page > 1">
            <div class="d-flex">
                <paginate
                    class="mb-0"
                    :page-count="dados.last_page"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-link'"
                    :next-class="'page-link'"
                    :prev-text="'<<'"
                    :next-text="'>>'"
                    :click-handler="paginar">
                </paginate>
            </div>
        </nav>

        <!-- Pré Atendimento -->
        <documento-pre-atendimento ref="doc_pre_atend" />

        <!-- Documentos -->
        <documento ref="documento" :recepcao="true" refresh="imprimir_documento" />

        <!-- Agendas de Infusão -->
        <agendar-infusao ref="aginf" :edicao_regiao="true" @refresh="load()" />

        <!-- Iniciar Atendimento -->
        <iniciar-atendimento ref="ini_atd_consultorio" @refresh="load(false)" />

        <!-- Cancelar Marcação -->
        <cancelar-marcacao ref="canc_atd_consultorio" @cancelado="load(false)" />

        <!-- Emitir Etiqueta -->
        <emitir-etiqueta ref="etiqueta" />

        <!-- Edição do Local do Painel -->
        <div class="modal fade" id="edicaoLocalModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="edicao_local">
                    <div class="modal-header">
                        <h5 class="modal-title">Atendimento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info mb-3">
                            <div class="lead">
                                {{ edicao_local.paciente.st_nome }}
                            </div>
                            <div>
                                <i class="fa fa-play fa-fw mr-2" aria-hidden="true"></i>
                                {{ lista_procs(edicao_local).map(item => item.descricao).join(', ') }}
                            </div>
                            <div>
                                <i class="fa fa-user-md fa-fw mr-2" aria-hidden="true"></i>
                                {{ edicao_local.medico.st_nome_exibicao }}
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input 
                                    label="Local"
                                    v-model="edicao_local.atendimento.st_as_local" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input 
                                    label="Responsável"
                                    v-model="edicao_local.atendimento.st_as_resp" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_local()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Paciente Primeira Vez -->
        <div class="modal fade" id="novoPacienteModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" v-if="marcacao && marcacao.cadastro_temporario">
                        <h5 class="modal-title" id="exampleModalLabel">{{ marcacao.cadastro_temporario.st_nome }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-header" v-if="marcacao && marcacao.paciente">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Paciente Agendado
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        </div>
                        <div class="modal-body">
                        <template v-if="marcacao && marcacao.paciente">
                            <div class="card">
                            <div class="card-body">
                                <celula-dados-paciente :hor="{ marcacao: marcacao }" />
                                <hr>
                                <celula-dados-procedimento :hor="{ marcacao: marcacao }" :blockanexos="true" />
                            </div>
                            </div>

                            <template v-if="marcacao.paciente.atendimento_pacotes">
                            <pacotes-do-paciente :pacotes="marcacao.paciente.atendimento_pacotes" />
                            </template>

                            <pre class="alert alert-warning" v-if="false">{{ marcacao.paciente }}</pre>
                        </template>
                        <az-empty-state msg="Paciente Primeira Vez." icon="far fa-user" v-else></az-empty-state>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-danger" @click="cancelarAtendimento(marcacao)" v-if="pode_atender">
                            Cancelar Marcação
                        </button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="iniciarAtendimento (marcacao)" v-if="pode_atender">Atendimento</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <selecao-medico-lista ref="selmed" @selecionados="filtrar_selecao_medicos" />

        <!-- Selecionar Painel -->
        <div class="modal fade" id="selecaoPainelModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Painel</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="paineis && paineis.length && item_painel">
                        <div class="alert alert-info">
                            <strong>{{ item_painel.paciente.st_nome }}</strong>
                            <div>{{ item_painel.procedimento.search }}</div>
                            <div>#{{ item_painel.id_atendimento }}</div>
                        </div>

                        <div class="list-group mb-3">
                            <button type="button" class="list-group-item list-group-item-action" v-for="(painel, ipx) in paineis" :key="ipx" @click="enviar_painel(painel)">
                                {{ painel.st_nome }}
                            </button>
                        </div>

                        <template v-if="item_painel.atendimento && item_painel.atendimento.atendimento_procedimentos">
                            <div class="form-row" v-for="(atp, iax) in item_painel.atendimento.atendimento_procedimentos" :key="iax">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="label"
                                        sizing="sm"
                                        :label="atp.procedimento.search">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-success" type="button" v-if="!atp.hr_proc_inicio" @click="atp_start_stop(atp)" :disabled="$store.state.loading">
                                                    <i class="fa-solid fa-play"></i>
                                                </button>
                                            </div>
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-danger" type="button" v-if="atp.hr_proc_inicio && !atp.hr_proc_termino" @click="atp_start_stop(atp)" :disabled="$store.state.loading">
                                                    <i class="fa-solid fa-stop"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        type="time"
                                        sizing="sm"
                                        v-model="atp.proc_inicio"
                                        :edicao="false" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        type="time"
                                        sizing="sm"
                                        v-model="atp.proc_termino"
                                        :edicao="false" />
                                </div>
                            </div>
                        </template>

                        <div class="mt-3">

                            <template v-if="lista_painel_local === null">
                                
                                <div>
                                    <div class="spinner-grow spinner-grow-sm mr-2" role="status">
                                    <span class="sr-only">Loading...</span>
                                    </div>
                                    Verificando Painéis...
                                </div>

                            </template>

                            <template v-else-if="lista_painel_local && !lista_painel_local.length">
                                
                                <div class="alert alert-warning">
                                    Nenhum painel encontrado.
                                </div>

                            </template>

                            <template v-else>

                                <div class="mb-3">
                                    <az-input 
                                        sizing="sm"
                                        label="Painel Selecionado"
                                        v-model="painel_local"
                                        :edicao="false" />
                                </div>

                                <div class="list-group" v-if="lista_painel_local && lista_painel_local.length">
                                    <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between" v-for="(item, iix) in lista_painel_local" :key="iix" @click="painel_local = item">
                                        {{ item }}
                                    </button>
                                </div>

                            </template>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Envio de Arquivo -->
        <template v-if="acao_anexar">
            <az-file-upload
                ref="upload"
                @refresh="carregar_arquivos()"
                :multiple="true"
                :arquivos="marcacao.arquivos"
                :parms="{ model_type: 'marcacao', model_id: marcacao.id_marcacao }" />
        </template>

        <!-- Internação -->
        <edicao-internacao ref="edit_intern" @refresh="load()" v-if="is_fila_intern" />

        <!-- Selecionar Leito -->
        <selecao-leito ref="selecao_leito" @refresh="load()" />

    </div>
</template>

<script>
import * as moment from 'moment';
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import CelulaDadosPaciente from "../../shared/table/CelulaDadosPaciente.vue";
import CelulaDadosProcedimento from "../../shared/table/CelulaDadosProcedimento.vue";
import EventBus from '../../../service/EventBus';
import DocumentoPreAtendimento from '../../shared/DocumentoPreAtendimento.vue';
import Documento from '../consultorio/Documento.vue';
import CardTarefas from '../../shared/tarefa/CardTarefas.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AgendarInfusao from './AgendarInfusao.vue';
import IniciarAtendimento from "../recepcao/IniciarAtendimento.vue";
import CancelarMarcacao from "../callcenter/CancelarMarcacao.vue";
import EmitirEtiqueta from '../../shared/EmitirEtiqueta.vue';
import CelulaHorariosMarcacao from "../../shared/table/CelulaHorariosMarcacao.vue";
import SelecaoMedicoLista from '../callcenter/SelecaoMedicoLista.vue';
import AtendimentoEnfermagemPainel from './AtendimentoEnfermagemPainel.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import EdicaoInternacao from '../internacao/EdicaoInternacao.vue';
import SelecaoLeito from '../internacao/SelecaoLeito.vue';

export default {
    data () { 
        return {
            dados: null, 
            from: moment().subtract(7, "days").format('YYYY-MM-DD'),
            to: this.$util.hoje(),
            filtro: { 
                id_fila_laudo: '', 
                id_status_laudo: "", 
                id_unidade_operacao: this.$util.getCookie('id_unidade_operacao'),
                id_centro_custo: "", 
                inicio: "",
                fim: "",
                periodo: "h",
                id_medico: "", 
                local: "", 
                paciente: "", 
                internados: false,
            },
            filas: [], 
            search: "",
            laudo: null, 
            page: 1, 
            canceltoken: null, 
            tem_paginacao: false, 
            search_timeout: null, 
            referencia: this.$util.hoje(), 
            refresher: null, 
            em_atend_fullscreen: false, 
            edicao_local: null, 
            retracao: [], 
            agora: moment().format("HH:mm:ss"), 
            tmaInterval: null, 
            pre_pode_finalizar: false, 
            marcacao: null, 
            pode_atender: false, 
            filtro_lista_medicos: [], 
            viewMode: 'A', 
            painel_execucao: null, 
            paineis: null, 
            item_painel: null, 
            painel_local: "", 
            lista_painel_local: [], 
            faixa_hora: '', 
            acao_anexar: false, 
        }
    },
    components: { 
        AzInput,
        AzEmptyState, 
        CelulaDadosPaciente, 
        CelulaDadosProcedimento,
        DocumentoPreAtendimento, 
        Documento, 
        CardTarefas, 
        AzSubmit, 
        AgendarInfusao, 
        IniciarAtendimento, 
        CancelarMarcacao, 
        EmitirEtiqueta, 
        CelulaHorariosMarcacao, 
        SelecaoMedicoLista, 
        AtendimentoEnfermagemPainel, 
        AzFileUpload, 
        EdicaoInternacao, 
        SelecaoLeito, 
    },
    
    props: ['vacina', 'cc'],

    watch: { 
        faixa_hora: function(newValue) { 
            this.$store.commit('setContexto', { enferm_faixa_hora: newValue });
        },
    }, 

    computed: { 
        lista_recepcoes: function () { 
            if ( !this.filtro.id_unidade_operacao ) { 
                return [];
            }

            let unid = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.filtro.id_unidade_operacao);

            if ( unid ) { 
                return unid.recepcaos;
            } else { 
                return [];
            }
        },

        lista_status: function () { 
            return _.map(
                _.groupBy(
                    _.flatMap(this.exibicao, items => items)
                        .map(item => { 
                            return this.checkStatus(item);
                        }),
                    'title'
                ),
                items => { 
                    return { 
                    ...items[0],
                    count: items.length
                    }
                }
            );
        },

        fila_cookie: function () { 
            return this.vacina ? 'vacina-fila' : 'enfermagem-fila';    
        },

        lista: function () { 
            if ( !this.dados || !this.dados.data )
                return [];

            if ( this.search && this.search.substr(0,1) == '#' && !isNaN(this.search.substr(1)) ) { 
                return this.dados.data.filter(item => item.id_atendimento == this.search.substr(1));
            } 

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados.data.filter(item => !this.filtro.id_status_laudo || item.id_status_laudo == this.filtro.id_status_laudo)
                    .filter (item => ( !this.search || reg.test(JSON.stringify(item)) ));
        },

        em_atendimento: function() { 
            if ( !this.dados || !this.dados.data )
                return [];

            return _.orderBy(
                this.dados.data.filter(item => item.id_atendimento && item.ch_estado_marcacao == 'A' && item.item_status.ultima_etapa.id_etapa_atendimento == 6),
                'atendimento.st_as_local'
            );
        },

        exibicao: function () { 
            let items = this.lista; 

            if ( !items.length )
                return [];

            if ( this.faixa_hora ) { 
                items = items.filter(item => { 
                    let hora = item.atendimento ? item.atendimento.dt_inicio.slice(11,16) : item.dt_inicio.slice(11,16);

                    return ( hora < '13:00' && this.faixa_hora == 'M' )
                    || ( hora >= '13:00' && hora < '18:00' && this.faixa_hora == 'T' )
                    || ( hora >= '13:00' && this.faixa_hora == 'TN' )
                    || ( hora >= '18:00' && this.faixa_hora == 'N' );
                });
            }

            if ( this.viewMode == 'G' ) { 

                items = _.groupBy(items, item => { 
                    return '  ' + item.medico.search;
                });     

            } else { 
            
                items = _.groupBy(items, item => { 
                    if ( !item.atendimento )
                        return '4 Marcados';

                    if ( item.ch_estado_marcacao == 'C' )
                        return '9 Cancelados';

                    if ( this.checkStatus(item) && this.checkStatus(item).title == 'Não Compareceu' ) 
                        return '8 Não Compareceu';

                    if ( this.checkStatus(item) && this.checkStatus(item).title == 'Em Atendimento...' ) 
                        return '1 Em Atendimento';
                        
                    return ( 
                            this.checkStatus(item) 
                            &&  ( 
                                this.checkStatus(item).title == 'Finalizado'
                                || this.checkStatus(item).title == 'Procedimento Concluído' 
                            )
                        )
                        ? '2 Finalizado' 
                        : ( 
                            ( 
                                ( 
                                    this.checkStatus(item) 
                                    &&  this.checkStatus(item).title == 'Atendido'
                                ) 
                            )
                            ? '3 Atendido' 
                            : ' Lista ' 
                        );
                });

            }

            let ordered = {};   
            _(items).keys().sort().each(function (key) {
                ordered[key] = items[key];
            });

          return ordered; 

        },

        fila: function () { 
            if ( !this.filtro.id_fila_laudo )
                return null;

            return this.filas.find(item => item.id_fila_laudo == this.filtro.id_fila_laudo);
        },  

        is_fila_intern: function () { 
            return this.fila && this.fila.fl_fila_intern;
        },  

    },

    methods: { 
        tratar_abertura_mounted (res) { 

            this.filas = res

            this.pre_pode_finalizar = ( this.$store.state.contexto['assistencia-pre-pode-finalizar'] == 1 );

            if ( res && res.length == 1 ) { 
                this.filtro.id_fila_laudo = res[0].id_fila_laudo;
            }

            if ( this.is_fila_intern ) { 
                this.filtro.id_medico = ""; 
            }

        },

        selecionar_leito (item) { 
            item.local = null; 
            this.$refs.selecao_leito.abrir(item);
        },
        registrar_alta(item) { 
            this.$refs.edit_intern.abrir_alta(item.id_internacao);
        },

        abrir_anexar_arquivo(marcacao) { 
            this.marcacao = marcacao;
            this.acao_anexar = true;

            if ( this.marcacao.arquivos && this.marcacao.arquivos.length && !this.marcacao.arquivos.find(arq => arq.arquivo) ) { 
                this.carregar_arquivos(true);
                return;
            }

            this.$nextTick(() => { 
                this.$refs.upload.abrir();
            });
        },

        carregar_arquivos (abrir = false) { 

            this.$store.commit('loading', true);

            this.$util.loadItem(this, { 
                service: 'arquivos',
                func: 'links',
                parms: { 
                    id: this.marcacao.id_marcacao, 
                    type: 'marcacao',
                }
            })
            .then(res => { 
                this.marcacao.arquivos = res;

                if ( abrir ) { 
                    this.$nextTick(() => { 
                    this.$refs.upload.abrir();
                    });
                }
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });

        },

        //

        atp_start_stop (atp) { 
            this.$util.atualizar(this, { 
                service: 'atendimentos', 
                func: 'atp_start_stop', 
                dados: { 
                    id_atendimento_procedimento: atp.id_atendimento_procedimento,
                },
                callback: res => { 
                    if ( res && res.atp ) { 
                        atp.hr_proc_inicio = res.atp.hr_proc_inicio;
                        atp.hr_proc_termino = res.atp.hr_proc_termino;
                        atp.proc_inicio = res.atp.proc_inicio;
                        atp.proc_termino = res.atp.proc_termino;
                    }
                },
            });
        },
        enviar_painel (painel) { 

            if ( !this.painel_local ) { 
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Painel não selecionado.',
                });
                return;
            }
            
            this.$util.atualizar(this, { 
                service: 'enfermagem',
                func: 'painel_execucao_notificar',
                dados: { 
                    id: this.item_painel.id_atendimento,
                    fila: this.filtro.id_fila_laudo,
                    painel: painel.id_fila_laudo_painel,
                    id_unidade_operacao: this.$util.getCookie('id_unidade_operacao'),
                    local: this.painel_local,
                },
                modal: 'selecaoPainelModal',
                toast: true, 
                msg: 'Enviado'
            });

        },

        selecionar_painel (item) { 

            this.item_painel = item; 
            this.lista_painel_local = null; 

            this.$util.loadItem(this, { 
                service: 'enfermagem', 
                func: 'lista_paineis', 
            })
            .then(res => { 
                this.lista_painel_local = res.lista || [];

                if ( this.lista_painel_local.contains(this.painel_local) ) { 
                    this.painel_local = ""
                }
            });

            $('#selecaoPainelModal').modal('show');

        },

        execucao () { 
            this.painel_execucao = !this.painel_execucao; 

            if ( this.painel_execucao ) { 
                this.$nextTick(() => { 
                    this.$refs.painel_execucao.abrir(
                        this.filtro.id_fila_laudo,
                        this.filtro.id_unidade_operacao, 
                        this.$util.getCookie('local-chamada')
                    );
                });
            }
        },

        filtrar_selecao_medicos (lista_selec) { 
            let lista = lista_selec.map(item => item.id_pessoa);

            if ( lista.length == 1 ) { 
                this.filtro_lista_medicos = [];
                this.filtro.id_medico = lista[0];  
            } else { 
                this.filtro.id_medico = "";
                this.filtro_lista_medicos = lista;
            }

            this.load(false);
        },

        selecionar_medicos () { 
            $('[data-toggle="tooltip"]').tooltip("dispose");
            this.$refs.selmed.abrir_carregando({ ativos: true, atendimento: true }, this.filtro_lista_medicos);
        },

        //

        pausar_login () { 
            this.$root.$children[0].pausar();
            // this.$root.$children[0].$refs.login_pausado.abrir();
        },

        printEtiqueta (marcacao) {
            this.$refs.etiqueta.emitir('marcacao', marcacao);
        },

        // Iniciar Atendimento...

        cancelarAtendimento(marcacao) {
            $('.modal').modal('hide');
            this.$refs.canc_atd_consultorio.cancelar(marcacao);
        },

        verPrimeiraVez (marcacao) { 

            this.marcacao = marcacao; 
            
            $('#novoPacienteModal').modal('show');

            if ( this.marcacao.paciente ) { // } && this.marcacao.fl_particular ) { 

                this.$util.load(this, { 
                    service: 'marcacoes',
                    func: 'show',
                    parms: { 
                        id: marcacao.id_marcacao, 
                        para_atendimento: true, 
                    },
                    loadTo: res => { 
                        this.marcacao.paciente = res.paciente;

                        if ( this.marcacao.procedimento.id_classe_procedimento == 17 
                            && this.marcacao.paciente.atendimento_pacotes
                            && this.marcacao.paciente.atendimento_pacotes.length ) { 

                            this.marcacao.direto = true; 

                        }
                    }
                });

            }
            
        },

        iniciarAtendimento (item) { 

            if ( item.direto ) { 

                let id_uo = this.$util.getCookie('id_unidade_operacao');
                let id_rc = this.$util.getCookie('id_unidade_operacao') ? this.$util.getCookie('id_recepcao') : null;

                let recep = this.$util.recepcao();

                if ( recep ) { 
                    id_uo = recep.id_unidade_operacao;
                    id_rc = recep.id_recepcao;
                }

                this.$util.atualizar(this, { 
                    service: 'marcacoes',
                    func: 'cerimonial_checkin',
                    dados: { 
                        id_marcacao: item.id_marcacao, 
                        id_unidade_operacao: id_uo,
                        id_recepcao: id_rc,
                        expresso: true, 
                        origem: 'consultorio',
                    },
                    modal: 'novoPacienteModal',
                    toast: true, 
                    callback: res => { 
                        console.log ('item', item);
                        console.log ('retorno', res);

                        if ( res && res.atendimento ) { 
                            // item.id_atendimento = res.atendimento.id_atendimento;
                            // item.atendimento = res.atendimento;
                        }

                        if ( res && res.expresso && res.atendimento ) { 
                            this.chamar({ marcacao: item }, res.atendimento);
                        }
                    }
                });

                return;
            }

            this.$store.commit("loading", true);

            let query = {
            q: [
                {
                name: "marcacoes.show",
                id: "item",
                parms: {
                    id: item.id_marcacao,
                    para_atendimento: true
                }
                }
            ]
            };

            this.axios
            .post("/aql", query)
            .then(res => {
                if (res.data.item.status == 200) {
                let marcacao = res.data.item.data;
                $('.modal').modal("hide");
                $('[data-toggle="tooltip"]').tooltip("dispose");
                this.$refs.ini_atd_consultorio.abrir(marcacao, 1);
                }
            })
            .finally(() => {
                this.$store.commit("loading", false);
            });

        },

        //
        agenda_infusao (marcacao) { 
            this.$refs.aginf.agendar(marcacao);
        },

        finalizar_pre (marcacao) { 
            if ( !confirm('Confirma finalizar o pré-atendimento do paciente?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'atendimentos',
                func: 'finalizar',
                dados: { 
                    id: marcacao.id_atendimento,
                    pre_atend: true, 
                    force: true, 
                },
                toast: true, 
                reload: true, 
            });  
        },

        finalizar (marcacao) { 
            if ( !confirm('Confirma finalizar o atendimento do paciente?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'atendimentos',
                func: 'finalizar',
                dados: { 
                    id: marcacao.id_atendimento,
                    force: true, 
                },
                toast: true, 
                reload: true, 
            });  
        },

        cor_etapa (marcacao) { 
            switch (marcacao.atendimento.progresso_atendimento_consultorio.id_etapa_atendimento) {
                case 5: return 'danger';
                case 6: return 'success';
                case 7: return 'dark';
                case 8: return 'secondary';
                case 9: return 'secondary';
                default: 'primary';
            }
        },

        calc_duracao(item, atendimento = null) { 
            if ( atendimento && atendimento.dt_inicio.substr(0,10) == this.$util.hoje() 
                && item.fl_iniciado && item.hr_proc_inicio ) { 

                let ini = item.hr_proc_inicio.substr(0,5); 
                let fim = item.hr_proc_termino ? item.hr_proc_termino.substr(0,5) : this.agora;

                ini = moment(ini, 'HH:mm:ss');
                fim = moment(fim, 'HH:mm:ss');

                let diff = fim.diff(ini);
                let duration = moment.utc(diff).format("HH:mm");

                if ( duration.substr(0,2) == '00' ) { 
                    duration = moment.utc(diff).format('m') + 'm';
                } 

                return duration;

            }
        },

        toggle_retracao(iq) { 
            let indice = iq.substr(0,1);
            this.retracao[indice] = this.retracao[indice] ? false : true;
            this.$util.setCookie('AS-RET-' + indice, this.retracao[indice] ? 1 : 0, 365);
            this.$forceUpdate();
        },

        salvar_local() { 
            this.$util.atualizar(this, { 
                service: 'enfermagem',
                func: 'salvar_local',
                dados: this.edicao_local.atendimento,
                modal: 'edicaoLocalModal',
                toast: true,
                reload: true, 
            });
        },

        editar_local(item) { 
            this.edicao_local = _.cloneDeep(item);

            $('#edicaoLocalModal').modal('show');
        },

        painel() { 
            this.painel_execucao = false;
            this.em_atend_fullscreen = !this.em_atend_fullscreen;
        },

        lista_procs (marcacao) { 
            return _.uniqBy(marcacao.atendimento.atendimento_procedimentos, 'id_procedimento').map(item => { 
                    return { 
                        descricao: item.procedimento.st_sigla 
                            ? item.procedimento.st_sigla 
                            : item.procedimento.st_procedimento,
                        color: ( 
                            ( item.fl_iniciado && item.hr_proc_inicio && item.hr_proc_termino )
                            ? 'success'
                            : ( item.fl_iniciado && item.hr_proc_inicio && !item.hr_proc_termino )
                                ? 'info'
                                : ( item.fl_iniciado && !item.hr_proc_inicio )
                                    ? 'warning'
                                    : 'secondary'
                        ),
                        duracao: this.calc_duracao(item, marcacao.atendimento),
                    };
                });
        },

        percentual_a_realizar(marcacao) { 
            if (!marcacao || !marcacao.atendimento)
                return 0;

            let marcados = _.uniqBy(
                marcacao.atendimento.atendimento_procedimentos.filter(item => item.procedimento.id_classe_procedimento != 1 
                    && item.fl_iniciado 
                    && !item.hr_proc_inicio),
                'id_procedimento').length;

            let total = _.uniqBy(
                marcacao.atendimento.atendimento_procedimentos.filter(item => item.procedimento.id_classe_procedimento != 1),
                'id_procedimento').length;
            
            return ( total > 0 ) ? Math.round((marcados / total) * 100) : 0;
        },

        percentual_execucao(marcacao) { 
            if (!marcacao || !marcacao.atendimento) { 
                return 0;
            }

            let marcados = _.uniqBy(
                marcacao.atendimento.atendimento_procedimentos.filter(item => item.procedimento.id_classe_procedimento != 1 && item.fl_iniciado && item.hr_proc_inicio),
                'id_procedimento').length;

            let total = _.uniqBy(
                marcacao.atendimento.atendimento_procedimentos.filter(item => item.procedimento.id_classe_procedimento != 1),
                'id_procedimento').length;
            
            return ( total > 0 ) ? Math.round((marcados / total) * 100) : 0;
        },

        adcionar_marcacao(marcacao) {
            $('[data-toggle="tooltip"]').tooltip("dispose");
            this.$router.push({
                name: "call-center",
                params: { adicao: marcacao.id_marcacao },
            });
        },

        novoDocumento(marcacao) { 
            this.$refs.documento.novoDocumento(marcacao);
        },

        refresh_local() { 
            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) {
                this.filtro.id_unidade_operacao = this.$util.getCookie('id_unidade_operacao');
                this.load();
            }
        },

        checkStatus (marcacao) { 
            if ( marcacao && !marcacao.atendimento && marcacao.dt_checkin ) { 
                return { 
                    status: 'agendado',
                    color: 'warning', 
                    title: 'Check-In',
                    icon: 'fas fa-user-check',
                    action: marcacao.paciente ? this.verPep : this.verPrimeiraVez
                } ;
            } else if ( marcacao && !marcacao.atendimento ) { 
                return { 
                    status: 'agendado',
                    color: 'info', 
                    title: 'Agendado',
                    icon: 'fas fa-user-clock',
                    action: marcacao.paciente ? this.verPep : this.verPrimeiraVez
                } ;
            } else if ( marcacao && marcacao.ch_estado_marcacao == 'C') { 
                return { 
                    status: 'cancelado',
                    color: 'secondary', 
                    title: 'Cancelado',
                    icon: 'fas fa-times',
                    action: null, 
                } ;
            } else if ( marcacao && marcacao.item_status.ultima_etapa && marcacao.item_status.ultima_etapa.ch_tipo_atendimento == 'P' ) { 
                if ( marcacao.item_status.ultima_etapa.id_etapa_atendimento == 11 ) { 
                    return { 
                        status: 'chamado-pre',
                        color: 'danger', 
                        title: 'Chamado Pré-Atendimento',
                        icon: 'fas fa-volume-up',
                        action: this.verPep
                    } ;
                } else if ( marcacao.item_status.ultima_etapa.id_etapa_atendimento == 12 ) { 
                    return { 
                        status: 'atendendo-pre',
                        color: 'success', 
                        title: 'Em Atendimento (*)...',
                        icon: 'success',
                        action: this.verPep
                    } ;
                } else if ( marcacao.item_status.ultima_etapa.id_etapa_atendimento == 13 ) { 
                    return { 
                        status: 'atendido-pre',
                        color: 'primary', 
                        title: 'Atendido',
                        icon: 'fas fa-check',
                        action: this.verPep
                    } ;
                }
            } else if ( marcacao && marcacao.item_status.ultima_etapa && marcacao.item_status.ultima_etapa.ch_tipo_atendimento == 'D' ) { 
                if ( marcacao.item_status.ultima_etapa.id_etapa_atendimento == 14 ) { 
                    return { 
                        status: 'chamado-pos',
                        color: 'danger', 
                        title: 'Chamado Para Procedimento',
                        icon: '',
                        action: this.verPep
                    } ;
                } else if ( marcacao.item_status.ultima_etapa.id_etapa_atendimento == 15 ) { 
                    return { 
                        status: 'atendendo-pos',
                        color: 'success', 
                        title: 'Em Procedimento...',
                        icon: '',
                        action: this.verRes
                    } ;
                } else if ( marcacao.item_status.ultima_etapa.id_etapa_atendimento == 16 ) { 
                    return { 
                        status: 'atendido-pos',
                        color: 'primary', 
                        title: 'Procedimento Concluído',
                        icon: '',
                        action: this.verPep
                    } ;
                }
            } else if ( marcacao && marcacao.item_status.ultima_etapa && marcacao.item_status.ultima_etapa.ch_tipo_atendimento == 'C' ) { 
                if ( marcacao.item_status.ultima_etapa.id_etapa_atendimento == 5 ) { 
                    return { 
                        status: 'chamado',
                        color: 'danger', 
                        title: 'Chamado',
                        icon: 'fas fa-volume-up',
                        action: this.verPep
                    };
                } else if ( marcacao.item_status.ultima_etapa.id_etapa_atendimento == 6 ) { 
                    return { 
                        status: 'atendendo',
                        color: 'success', 
                        title: 'Em Atendimento...',
                        icon: 'success',
                        action: this.verRes
                    } ;
                } else if ( marcacao.item_status.ultima_etapa.id_etapa_atendimento == 7 ) { 
                    return { 
                        status: 'atendido',
                        color: 'primary', 
                        title: 'Finalizado',
                        icon: 'fas fa-check',
                        action: this.verRes
                    } ;
                } else if ( marcacao.item_status.ultima_etapa.id_etapa_atendimento == 9 ) { 
                    let fila = this.get_fila();

                    return { 
                        status: 'pausado',
                        color: 'success', 
                        title: fila.fl_pos_atendimento ? 'Chamar Paciente' : 'Pausado',
                        icon: '',
                        action: this.chamar,
                        fill: fila.fl_pos_atendimento ? true : false, 
                    };
                } else if ( marcacao.item_status.ultima_etapa.id_etapa_atendimento == 10 ) { 
                    return { 
                        status: 'nao-compareceu',
                        color: 'secondary', 
                        title: 'Não Compareceu',
                        icon: 'fas fa-check',
                        action: this.verRes
                    } ;
                }
            } else { 
                if ( marcacao.outras && marcacao.outras.find(item => item.item_status.valor == 'em atendimento' || item.item_status.valor == 'em pre-atendimento') ) { 
                    return { 
                            status: 'chamar',
                            color: 'dark', 
                            title: 'Em Outro Atendimento...',
                            icon: 'fas fa-ban',
                            fill: false,
                            action: this.verPep
                        } ;    
                } else if ( !marcacao.item_status.na_recepcao && marcacao.item_status.ultima_etapa.id_etapa_atendimento > 1 ) { 
                    if ( marcacao.item_status.block_proc ) { 
                        return {  
                            status: 'chamar',
                            color: 'secondary', 
                            title: 'Aguardando ' + marcacao.item_status.block_proc + '...',
                            icon: '',
                            fill: false,
                            action: this.verPep 
                        };    
                    } else { 
                        return { 
                            status: 'chamar',
                            color: 'success', 
                            title: 'Chamar Paciente',
                            icon: 'fas fa-bell',
                            fill: true,
                            action: this.chamar 
                        } ;    
                    }
                }

                return { 
                    status: 'recepção',
                    color: 'warning', 
                    title: 'Na Recepção',
                    icon: 'fas fa-user-friends',
                    fill: false,
                    action: this.mensagem 
                } ;    
            }
        },

        refresh_se_necessario () { 
            if ( !this.tem_paginacao )
                return;

            this.page = 1;
            this.$store.commit("loading", true);

            if (this.search_timeout) clearTimeout(this.search_timeout);

            this.search_timeout = setTimeout(() => {
                this.load();
                this.search_timeout = null;
            }, 300);

        },

        paginar (page) {
            this.page = page;
            this.load(false);
        },

        laudo_status(status) {

            this.$util.atualizar(this, { 
                service: 'laudos',
                func: 'status',
                dados: { 
                    id_laudo: this.laudo.id_laudo,
                    id_status_laudo: status.id_status_laudo,
                    local: this.$util.getCookie('local-chamada')
                },
                toast: true, 
                modal: 'procedimentoModal', 
                callback: res => { 
                    if ( res == 'OK' ) { 
                        this.load();
                    }
                }
            });

        },

        abrirLaudo(laudo) { 
            if ( this.fila && this.fila.fl_fila_procedimento ) { 
                this.laudo = laudo;

                $('#procedimentoModal').modal('show');
                return;
            }

            this.$router.push({path: '/laudos/' + laudo.id_laudo + '/' + this.filtro.id_fila_laudo});
        },

        dados_paciente(laudo) { 
            return { 
                marcacao: { 
                    plano: laudo.atendimento_procedimento.atendimento.plano,
                    paciente: laudo.atendimento_procedimento.atendimento.paciente, 
                }
            };
        },

        dados_procedimento(laudo) { 
            return { 
                marcacao: { 
                    procedimento: laudo.atendimento_procedimento.procedimento,
                    medico: laudo.atendimento_procedimento.atendimento.medico, 
                    arquivos: laudo.atendimento_procedimento.atendimento.marcacao.arquivos,
                    doc_pre_atends: laudo.atendimento_procedimento.atendimento.marcacao.doc_pre_atends, 
                    unidade_operacao: laudo.atendimento_procedimento.atendimento.marcacao.unidade_operacao, 
                }
            };
        },

        get_fila() { 
            return this.filas.find(item => item.id_fila_laudo == this.filtro.id_fila_laudo);
        },

        load() { 
            if ( this.refresher ) { 
                clearInterval(this.refresher);
                this.refresher = null;
            }

            this.$util.setCookie(this.fila_cookie, this.filtro.id_fila_laudo);
            this.$util.setCookie('enf-cc', this.filtro.id_centro_custo ? this.filtro.id_centro_custo : "");
            this.$util.setCookie('enf-int', this.filtro.internados ? 'S' : "");

            if ( !this.filtro.id_fila_laudo ) { 
                this.dados = null;
                return;
            }

            //

            let id_rc = null; 

            if ( this.filtro.id_unidade_operacao && ( this.filtro.id_unidade_operacao == this.$util.getCookie('id_unidade_operacao') ) ) { 
            
                let recep = this.$util.recepcao();

                if ( recep && recep.id_unidade_operacao == this.filtro.id_unidade_operacao ) { 
                    id_rc = recep.id_recepcao;
                }

            }

            //

            let fila = this.get_fila();

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            this.$store.state.user.assist_id_medico = this.filtro.id_medico;

            if ( fila && fila.fl_fila_procedimento ) { 
                this.$util.load(this, { 
                    service: this.vacina ? 'vacina' : 'enfermagem',
                    func: 'fila',
                    canceltoken: this.canceltoken.token,
                    parms: { 
                        referencia: this.referencia, 
                        fila: true, 
                        ...this.filtro,
                        id_recepcao: id_rc,
                        medicos: ( this.filtro_lista_medicos && this.filtro_lista_medicos.length ) ? this.filtro_lista_medicos : null , 
                        page: this.page,
                        size: 100, 
                        search: ( this.tem_paginacao || this.search.substr(0,1) == '#' ) ? this.search : '', 
                        tarefas: true, 
                    },
                    loadTo: res => { 
                        this.dados = res.lista;
                        this.tarefas = res.tarefas;
                        this.pode_atender = res.pode_atender;

                        if ( res.referencia ) { 
                            this.referencia = res.referencia;
                        }
                    }, 
                    final: () => { 
                        if ( this.dados && this.dados.last_page > 1 ) { 
                            this.tem_paginacao = true;
                        }

                        if ( this.refresher ) { 
                            clearInterval(this.refresher);
                            this.refresher = null;
                        }

                        this.refresher = setInterval(() => {
                            if ( $('.modal').is(':visible') ) { 
                                // 
                            } else if ( !this.$store.state.loading && this.$route.path == '/assistencia/atend' ) { 
                                this.load(false);
                            }

                            console.log('Refresh(E)', new Date().toISOString());
                        }, 60000);
                    }
                });
                return;
            }

            this.$util.load(this, { 
                service: this.vacina ? 'vacina' : 'enfermagem',
                func: 'fila',
                canceltoken: this.canceltoken.token,
                parms: { 
                    referencia: this.referencia, 
                    fila: true, 
                    from: this.from,
                    to: this.to,
                    ...this.filtro,
                    id_recepcao: id_rc,
                    medicos: ( this.filtro_lista_medicos && this.filtro_lista_medicos.length ) ? this.filtro_lista_medicos : null , 
                    page: this.page,
                    size: 200, 
                    search: ( this.tem_paginacao || this.search.substr(0,1) == '#' ) ? this.search : '', 
                    tarefas: true, 
                },
                loadTo: res => { 
                    this.dados = res.lista;
                    this.tarefas = res.tarefas;
                    this.pode_atender = res.pode_atender;
                    this.paineis = res.paineis;
                }, 
                final: () => { 
                    if ( this.dados && this.dados.last_page > 1 ) { 
                        this.tem_paginacao = true;
                    }

                    if ( this.refresher ) { 
                        clearInterval(this.refresher);
                        this.refresher = null;
                    }

                    this.refresher = setInterval(() => {
                        if ( $('.modal').is(':visible') ) { 
                            // 
                        } else if ( !this.$store.state.loading && this.$route.path == '/assistencia/atend' ) { 
                            this.load(false);
                        }
                        
                        console.log('Refresh(E)', new Date().toISOString());
                    }, 60000);
                }
            });
        },

        chamar (marcacao) { 
            let fila = this.get_fila();

            if ( fila && ( fila.fl_pre_atendimento || fila.fl_pos_atendimento ) ) { 
                //
            } else { 
                if ( !this.validar_consulta(marcacao) ) { 
                    return;
                }
            }

            this.$store.commit('loading', true);

            marcacao.loading = true;

            let query = { q: [
                { 
                    name: "atendimentos.chamar",
                    id: "chamada",
                    parms: { 
                        id: marcacao.atendimento.id_atendimento, 
                        id_recepcao: this.$util.getCookie('id_unidade_operacao') ? this.$util.getCookie('id_recepcao') : null,
                        local: this.$util.getCookie('local-chamada'),
                        block_painel: this.$util.getCookie('nao-enviar-painel'), 
                        pre_atend: fila ? fila.fl_pre_atendimento : false, 
                        pos_atend: fila ? fila.fl_pos_atendimento : false, 
                        enfermagem: true, 
                        fila: fila ? fila.id_fila_laudo : null, 
                    }
                }
            ]};

            this.axios.post('/aql?a=atendimentos.chamar', query)
                .then(res => { 
                    if ( !res.data )
                        return;

                    if ( res.data.chamada.status == 200 ) { 

                        if ( process.env.VUE_APP_GTAG ) { 

                            let action = 'chamar-enfermagem';
                            let label = this.$store.state.user.st_login;

                            this.$gtag.event(action, {
                                'event_category': window.redir,
                                'event_label': label,
                                'value': 1
                            });

                        }

                        marcacao.item_status.ultima_etapa = res.data.chamada.data.etapa_atendimento;
                        this.$store.commit('loading', false);

                        if ( marcacao.item_status.ultima_etapa.id_etapa_atendimento == 9 ) { 
                            this.verRes (marcacao);
                        } else { 
                            this.verPep(marcacao);
                        }
                    }
                })
                .finally (() => { 
                    this.$store.commit('loading', false);
                    marcacao.loading = false;
                });
        },

        validar_consulta (marcacao) { 

            if ( marcacao.atendimento 
                && marcacao.atendimento.atendimento_procedimentos 
                && marcacao.atendimento.atendimento_procedimentos.length == 1 
                && marcacao.atendimento.atendimento_procedimentos[0].procedimento.id_classe_procedimento == 1 ) {

                if ( marcacao.atendimento.id_medico != this.$store.state.user.id_pessoa ) { 

                    if ( !this.$util.is_usuario_delegado(marcacao.atendimento.id_medico) ) { 

                        this.$toast.add({
                            severity: "warn",
                            summary: "Atenção",
                            detail: "Atendimento dessa consulta registrado para " + marcacao.medico.st_nome_exibicao,
                            life: 5000
                        });
                        return false;

                    }

                }

            }

            return true;

        },

        verPep (marcacao) {
            let fila = this.get_fila();

            if ( fila && fila.fl_pre_atendimento ) { 
                $('[data-toggle="tooltip"]').tooltip('hide');
                this.$router.push({path: '/assistencia/pre/' + marcacao.id_marcacao + '/' + this.filtro.id_fila_laudo});
                return;                
            }

            if ( fila && fila.fl_pos_atendimento ) { 
                //
            } else if ( !this.validar_consulta(marcacao) ) { 
                return;
            }

            $('[data-toggle="tooltip"]').tooltip('hide');

            if ( this.vacina ) { 
                this.$router.push({path: '/vacina/historico/' + marcacao.id_paciente + '/' + this.filtro.id_fila_laudo});
            } else if ( this.cc ) { 
                this.$router.push({path: '/centro-cirurgico/historico/' + marcacao.id_paciente + '/' + this.filtro.id_fila_laudo});
            } else {     
                this.$router.push({path: '/assistencia/historico/' + marcacao.id_paciente + '/' + this.filtro.id_fila_laudo + '/' + marcacao.id_atendimento});
            }
        },

        verRes (marcacao) { 
            $('[data-toggle="tooltip"]').tooltip('hide');

            if ( marcacao.atendimento 
                && marcacao.atendimento.atendimento_procedimentos 
                && marcacao.atendimento.atendimento_procedimentos.length == 1 
                && marcacao.atendimento.atendimento_procedimentos[0].procedimento.id_classe_procedimento == 1 ) { 

                // Fila de Pré-Atendimento

                let fila = this.get_fila();

                if ( fila && fila.fl_pre_atendimento ) { 
                    $('[data-toggle="tooltip"]').tooltip('hide');
                    this.$router.push({path: '/assistencia/pre/' + marcacao.id_marcacao + '/' + this.filtro.id_fila_laudo});
                    return;                
                }

                //

                if ( marcacao.atendimento.id_medico != this.$store.state.user.id_pessoa ) { 

                    if ( !this.$util.is_usuario_delegado(marcacao.atendimento.id_medico) ) { 

                        this.$toast.add({
                            severity: "warn",
                            summary: "Atenção",
                            detail: "Atendimento dessa consulta registrado para " + marcacao.medico.st_nome_exibicao,
                            life: 5000
                        });
                        return;

                    }
                    
                }

                this.$router.push({path: '/consultorio/res/' + marcacao.atendimento.id_atendimento + '/' + this.filtro.id_fila_laudo});
                return;

            }

            if ( this.vacina ) { 
                this.$router.push({path: '/vacina/atendimento/' + marcacao.atendimento.id_atendimento + '/' + this.filtro.id_fila_laudo});
            } else if ( this.cc ) { 
                this.$router.push({path: '/centro-cirurgico/atendimento/' + marcacao.atendimento.id_atendimento + '/' + this.filtro.id_fila_laudo});
            } else { 
                this.$router.push({path: '/assistencia/atendimento/' + marcacao.atendimento.id_atendimento + '/' + this.filtro.id_fila_laudo});
            }
        },

        verConsultorio (marcacao) { 
            $('[data-toggle="tooltip"]').tooltip('hide');

            this.$util.atualizar(this, { 
                service: 'atendimentos', 
                func: 'iniciar',
                dados: { 
                    id: marcacao.id_atendimento,
                    blockprogresso: true, 
                },
                callback: () => { 
                    this.$router.push({path: '/assistencia/atendimento/' + marcacao.id_atendimento + '/' + this.filtro.id_fila_laudo});
                }
            });

            //this.$router.push({path: '/consultorio/res/' + marcacao.id_atendimento + '/' }); // + this.filtro.id_fila_laudo});
        },
    },

    beforeMount() { 
        this.faixa_hora = _.get(this.$store.state.contexto, 'enferm_faixa_hora');

        if ( this.$store.state.user.assist_id_medico ) { 
            
            this.filtro.id_medico = this.$store.state.user.assist_id_medico;

        } else if ( this.$store.state.user.medico 
            && this.$store.state.user.medico.conselho 
            && this.$store.state.user.medico.conselho.st_sigla != 'COREN' ) { 

            this.filtro.id_medico = this.$store.state.user.medico.id_pessoa;

        }

        this.retracao[1] = this.$util.getCookie('AS-RET-1') == 1;
        this.retracao[2] = this.$util.getCookie('AS-RET-2') == 1;
        this.retracao[3] = this.$util.getCookie('AS-RET-3') == 1;
        this.retracao[4] = this.$util.getCookie('AS-RET-4') == 1;

        this.filtro.id_fila_laudo = this.$util.getCookie(this.fila_cookie);
        this.filtro.id_centro_custo = this.$util.getCookie('enf-cc') ? this.$util.getCookie('enf-cc') : "";
        this.filtro.internados = this.$util.getCookie('enf-int') == 'S' ? true : false;

    },

    beforeDestroy () { 
      EventBus.$off('refresh-local', this.refresh_local);

      if ( this.refresher ) { 
          clearInterval(this.refresher);
          this.refresher = null;
      }
    },

    destroyed() {
      if (this.tmaInterval) {
        clearInterval(this.tmaInterval);
        this.tmaInterval = null;
      }
    },

    mounted() { 
        EventBus.$on('refresh-local', this.refresh_local);

        this.tmaInterval = setInterval(() => {
            this.agora = moment().format("HH:mm:ss");
        }, 1000 * 20);

        let parms;
        let chave_cache; 

        if ( this.vacina ) { 

            this.$store.commit("setBreadcrumb", [
                { name: "Vacina", path: "/vacina" },
            ]);

            parms = { 
                vacina: true, 
            };

            chave_cache = 'vac';

        } else if ( this.cc ) { 

            this.$store.commit("setBreadcrumb", [
                { name: "Centro Cirúrgico", path: "centro-cirurgico/marcacao" },
                { name: "Atendimento", path: "centro-cirurgico/atendimento" },
            ]);

            parms = { 
                enfermagem: true, 
                cc: true, 
            };

            chave_cache = 'cc';
            
        } else { 

            this.$store.commit("setBreadcrumb", [
                { name: "Assistência", path: "/assistencia/atend" },
                { name: "Atendimento", path: "/assistencia/atend" },
            ]);

            parms = { 
                enfermagem: true, 
            };

            chave_cache = 'enf';

        }

        let info_cache = this.$store.state.options['filas_' + chave_cache]; 

        if ( info_cache ) { 

            this.tratar_abertura_mounted(info_cache);

        } else { 

            this.$util.loadItem(this, { 
                service: 'fila_laudos',
                func: 'index',
                parms: parms, 
                configs: [
                    'assistencia-pre-pode-finalizar', 
                ]
            })
            .then(res => { 
                this.tratar_abertura_mounted(res);
                this.$store.commit('setOptions', { name: 'filas_' + chave_cache, list: res });
            });

        }

    }
    
}
</script>

<style scoped>
.panel-fullscreen {
  display: block;
  z-index: 1031;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow: auto;
}
</style>

